import React from 'react';
import { BadgeCheckIcon, FileCheck2Icon, GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#09281d] px-5 py-20" data-id="element-82" data-mp="4xclkwxcokc2">
      <div className="mx-auto max-w-3xl border-t-8 border-emerald-400 bg-white p-8 text-center shadow-2xl sm:p-14" data-id="element-83" data-mp="9u37i0vu6a5e">
        <p className="inline-flex items-center gap-2 bg-emerald-500 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-84" data-mp="eu8uh3r5v8h5">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-85" data-mp="jqpt4rvzl58h" /> Zero rischi · 100% protetto
        </p>
        <ShieldCheckIcon className="mx-auto mt-7 h-20 w-20 text-emerald-700" strokeWidth={1.4} data-id="element-86" data-mp="ns1c4ekcus7p" />
        <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-none text-[#09281d] sm:text-6xl" data-id="element-87" data-mp="xjxjkg8bzuol">
          Garanzia di <span className="text-emerald-700" data-id="element-88" data-mp="12jtgjvim2lun">7 giorni</span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg font-medium text-slate-600" data-id="element-89" data-mp="17i4qs7ctiyde">
          Apri tutto. Usa il materiale. Mettilo alla prova.
        </p>
        <p className="mt-5 text-2xl font-bold leading-tight text-[#09281d]" data-id="element-90" data-mp="25ti4ef3v0gxw">
          Se EDUFIS PRONTO non trasforma il modo in cui pianifichi e gestisci le
          tue lezioni di Scienze Motorie,{' '}
          <span className="text-emerald-700" data-id="element-91" data-mp="1vu9b7ogtj6cl">
            ti rimborseremo ogni centesimo — senza domande.
          </span>
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3 text-xs font-bold text-[#09281d]" data-id="element-92" data-mp="2oieyoiz9b9g4">
          <span className="flex items-center gap-1.5" data-id="element-93" data-mp="2jjllysrsnmh0">
            <ZapIcon className="h-4 w-4 text-emerald-700" data-id="element-94" data-mp="2jk3p89cvj0yf" /> Rimborso semplice
          </span>
          <span className="flex items-center gap-1.5" data-id="element-95" data-mp="2er27zup72pbo">
            <FileCheck2Icon className="h-4 w-4 text-emerald-700" data-id="element-96" data-mp="2arjon3d0umay" /> Nessun
            modulo da compilare
          </span>
          <span className="flex items-center gap-1.5" data-id="element-97" data-mp="379xyyi1wc9eg">
            <GiftIcon className="h-4 w-4 text-emerald-700" data-id="element-98" data-mp="32i7o8az1rjmi" /> I bonus restano
            tuoi
          </span>
        </div>
        <p className="mt-6 inline-block border border-emerald-500/40 bg-emerald-50 px-4 py-2 text-xs font-bold uppercase tracking-widest text-emerald-800" data-id="element-99" data-mp="10k47orgdw0d4">
          Garanzia soddisfatti o rimborsati
        </p>
      </div>
    </section>;
}